import { useTranslation } from 'react-i18next';
import { IContextSheetContentProps, ISheetConfig } from '@/components/ui/ContextSheet';
import { ActionList, IActionItem } from '@/components/ui/ActionList';

export interface IMuteDurationPayload {
  postId: number;
  onDurationSelected: (minutes: number) => void;
}

const DURATION_OPTIONS = [
  { label: 'post.mute.oneHour', value: 60 },
  { label: 'post.mute.eightHours', value: 480 },
  { label: 'post.mute.oneDay', value: 1440 },
  { label: 'post.mute.indefinitely', value: -1 },
];

export function MuteDurationSheet({ onClose, payload }: IContextSheetContentProps) {
  const { t } = useTranslation();
  const { postId, onDurationSelected } = payload as IMuteDurationPayload;

  const handleDurationSelect = (minutes: number) => {
    onDurationSelected(minutes);
    onClose?.();
  };

  const actionOptions = DURATION_OPTIONS.map(option => ({
    label: t(option.label),
    value: option.value,
  }));

  return (
    <ActionList
      options={actionOptions}
      onSelect={handleDurationSelect}
    />
  );
}

MuteDurationSheet.sheetConfig = {
  hideCloseButton: true,
} satisfies ISheetConfig;
